<template src="./ModalArrivalChangeStatusComponent.html"></template>
<script>
import IconHome from "@/components/icons/IconHome.vue";
import BreadcrumbComponent from "@/components/breadcrumb/BreadcrumbComponent.vue";
import InputTextNormal from "@/components/inputs/input-text/normal/InputTextNormal.vue";
import SelectNormal from "@/components/inputs/select/normal/SelectNormal.vue";
import ButtonSearchComponent from "@/components/buttons/button-search/ButtonSearchComponent.vue";
import {ref, watch, computed} from "vue";
import LabelPriority from "@/components/labels/label-priority/LabelPriority.vue";
import LabelStatus from "@/components/labels/label-status/LabelStatus.vue";
import IconEye from "@/components/icons/IconEye.vue";
import ButtonAddComponent from "@/components/buttons/button-add/ButtonAddComponent.vue";
import InputTextareaNormal from "@/components/inputs/input-textarea/normal/InputTextareaNormal.vue";
import IconEdit from "@/components/icons/IconEdit.vue";
import IconTrash from "@/components/icons/IconTrash.vue";
import InputCheckboxOne from "@/components/inputs/input-checkbox/normal/InputCheckboxNormal.vue";
import {AppConstant} from "@/supports/app.constant";
import {useAccountStore} from "@/stores/account.js";
import PaginateComponent from "@/components/paginate/PaginateComponent.vue";
import CommonService from "@/services/common.service";
import {useSettingFormatFileStore} from "@/stores/settingFormatFile.js";
import {ErrorMessageConstant, ErrorText, SuccessMessageConstant} from "@/supports/error-message.constant.ts";
import {useArrivalStore} from "@/stores/arrival.js";
import ErrorMessageService from "@/services/error-message.service.js";
export default {
  name: 'ModalArrivalChangeStatusComponent',
  components: {
    PaginateComponent,
    InputCheckboxOne,
    IconTrash, IconEdit,
    InputTextareaNormal,
    ButtonAddComponent,
    IconEye,
    LabelStatus,
    LabelPriority, ButtonSearchComponent, SelectNormal, InputTextNormal, BreadcrumbComponent, IconHome,
  },
  props: {
    showModal: {
      type: Boolean,
      required: false,
      default: () => false
    },
    eventClickShowModal: {
      type: Boolean,
      required: false,
      default: () => false
    },
    arrival: {
      type: Object,
      required: false,
    },
  },
  emits: ['showModal', 'errorMessage', 'statusChange'],
  setup(props, { emit }) {
    const errors = ref(true)
    const errorMessage = ref([])
    const dataModal = ref({
      status: {
        id: 'status',
        label: '',
        placeholder: 'Trạng thái',
        value: '',
        error: '',
        isError: false,
        required: false,
        disable: false,
        options: [
          {
            name: 'Đang chuẩn bị',
            value: 1
          },
          {
            name: 'Đang di chuyển',
            value: 2
          },
          {
            name: 'Đã nhập hàng',
            value: 3
          },
        ]
      },
    })
    const clickShowModal = ref(false)
    const accountStore = useAccountStore()
    const arrivalStore = useArrivalStore()
    watch(() => props.eventClickShowModal, (eventClickShowModal) => {
      errorMessage.value = [];
      clickShowModal.value = eventClickShowModal
      dataModal.value.status.value = props.arrival.status;
      emit('showModal', true)
    })

    function onChange(value, name) {
      dataModal.value[name].value = value;
    }

    async function eventChangeStatus() {
      for (const item in dataModal.value) {
        validateForm(dataModal.value[item].value, item)
      }
      if(checkSubmitActive.value) {
        const params = {
          m_company_id: accountStore.account.company.id,
          id: props.arrival.id,
          status: dataModal.value.status.value,
          warehouse_id: props.arrival.warehouse.id,
          product_id: props.arrival.product.id,
        }
        const url = AppConstant.URL_API_LOCAL + 'api/arrival/change-status';
        const res = await arrivalStore.changeStatusArrival(url, params);
        const errorMessageRes = await ErrorMessageService.getErrorMessage(res)
        if((typeof errorMessageRes === 'string' && errorMessageRes) || (typeof errorMessageRes === 'array' && errorMessageRes.length > 0)) {
          errorMessage.value = typeof errorMessageRes === 'string' ? [errorMessageRes] : errorMessageRes;
          emit('errorMessage', errorMessageRes)
          emit('showModal', true)
        }else {
          await CommonService.showAlertPopup({
            title: res.message,
            icon: 'success',
            showConfirmButton: false,
            timer: 2000,
            width: '800px'
          });
          emit('statusChange', dataModal.value.status.value)
          dataModal.value.status.value = ''
          emit('showModal', false)
        }
      }
    }

    const checkSubmitActive = computed(() => {
      return !errors.value;
    })

    function validateForm(value, name) {
      if(name === 'status') {
        dataModal.value.status.isError = false;
        dataModal.value.status.error = ''
        errors.value = false
        if(!value) {
          dataModal.value.status.isError = true;
          dataModal.value.status.error = ErrorText.REQUIRED(dataModal.value.status.label);
          errors.value = true
        }
        if(!errors.value && value < props.arrival.status) {
          dataModal.value.status.isError = true;
          errorMessage.value = [ErrorMessageConstant.ERROR_ARRIVAL_CHANGE_STATUS_NOT_BACK];
          errors.value = true
        }
      }
    }

    function removeError(key) {
      errorMessage.value.splice(key, 1)
    }

    return {
      dataModal,
      errorMessage,
      onChange,
      eventChangeStatus,
      removeError,
      CommonService
    }
  },
}
</script>
<style lang="scss">
#modalArrivalChangeStatus {
  .modal-content {
    background: #ffffff;
  }

  .modal-body {
    .select-form, .input-number {
      width: 172px;
    }
  }
  .modal-header {
    border-bottom: 1px solid #d9dee3;
  }
}
@media (min-width: 1200px) {
  .modal-xxl {
    max-width: 1540px;
  }
}
</style>
